<template>
  <!-- Mobile Dialog -->
  <q-dialog v-if="isMobile" v-model="isVisible" maximized position="standard">
    <q-card class="account-dialog">
      <q-card-section class="row items-center q-pb-none q-pt-md q-px-md">
        <q-btn flat round icon="arrow_back" @click="goBack" class="q-mr-sm" />
        <div class="text-h6 text-weight-medium text-grey-8">{{$t('Account')}}</div>
        <q-space />
      </q-card-section>
      
      <q-card-section class="q-pa-sm">
        <AccountSettings />
      </q-card-section>
    </q-card>
  </q-dialog>

  <!-- Desktop Dialog -->
  <q-dialog v-else v-model="isVisible" position="standard">
    <q-card class="account-dialog">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6 text-grey-8">{{$t('Account')}}</div>
        <q-space />
        <q-btn flat round dense icon="close" @click="goBack" />
      </q-card-section>
      
      <q-card-section class="q-pa-sm">
        <AccountSettings />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useQuasar } from 'quasar'
import AccountSettings from './account-settings.vue'

const $q = useQuasar()

const props = defineProps({
  visible: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['back'])

const isVisible = ref(props.visible)
const isMobile = computed(() => $q.screen.lt.md)

watch(() => props.visible, (newVal) => {
  isVisible.value = newVal
})

const goBack = () => {
  isVisible.value = false
  emit('back')
}
</script>

<style lang="scss" scoped>
.text-grey-8 {
  body.body--dark & {
    color: white !important;
  }
}
</style>